export default function alertDirective($sce) {
  'ngInject';
  return {
    restrict: 'A',
    scope: {
      alert: '=',
      close: '='
    },
    template: `
      <div ng-if="!alert.template" class="alert-box alert-box-{{alert.type}}" id="alert-{{alert.id}}">
        <a class="close-button" ng-if="close" ng-click="close(alert.id)">&times;</a>
        <div class="alert-content">
          <div class="alert-content-text" ng-bind-html="message"></div>
        </div>
      </div>
      <ng-include class="alert-container" ng-if="alert.template" src="alert.template"></ng-include>
    `,
    link: function ($scope) {
      $scope.message = $sce.trustAsHtml($scope.alert.message);
      if($scope.alert.template  === 'alert') $scope.alert.template = undefined;
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/shared/directives/alerts/alert.directive.js
 **/